import React, { useState } from "react";
import TownPlanningSidebar from "../components/TownPlanningSidebar";
import styles from "../styles/TownPlanningDashboard.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FaArrowLeft, FaSearch, FaDownload, FaFilter, FaCalculator, FaFilePdf } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
export default function AboutUs() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const handleBack = () => {
    navigate("/")
  };
  return (
    <div
      className={styles.homeScreenContainer}
      style={{
        height: "100vh",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <div className={styles.homeScreenHeader}>
        {/* <button
          onClick={() => setIsSidebarOpen(true)}
          className={styles.homeScreenMenuBtn}
        >
          <FontAwesomeIcon icon={faBars} />
        </button> */}

        
        <button className={styles.homeScreenMenuBtn} onClick={handleBack}>
          <FaArrowLeft />
        </button>

        <TownPlanningSidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />

        <h2 style={{ color: "white" }}>About US</h2>
      </div>

      {/* Scrollable Content Area */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "20px",
          color: "white",
          textAlign: "center"
        }}
      >

        <p style={{ fontSize: "10px", lineHeight: "1.8" }}>

          <br /><br />

          <strong style={{ fontSize: "18px" }}>Concept, Idea, Design</strong><br />
          Shri. Saurabh Bapurao Navarkar (SN33)<br />
          Town Planner<br /> <br /> <br />

          <strong style={{ fontSize: "18px" }}>Development</strong><br />
          Vishvaconnect Technologies LLP<br /> <br /><br />

          <strong style={{ fontSize: "18px" }}>Contribution</strong><br />
          Shri. Nilesh Gadge,<br />
          Assistant Town Planner<br /><br /><br />

          <strong style={{ fontSize: "18px" }}>Vote of Thanks</strong><br />
          DIRECTOR OF TOWN PLANNING<br />
          Pune

        </p>


      </div>
    </div>
  );
}
